import store from "../store";

export default class ErrorService {
  //Will need to do some logging in future
  static onError(error: any): void {
    const response = error.response;
    if (error.code === "PERMISSION_DENIED") {
      store.dispatch("authenication/userLogoutAsync");
    }
    if (response && response.status >= 400 && response.status < 405) {
      console.log(response);
    }
  }
}
